import { render, staticRenderFns } from "./TkRightArrowButton.vue?vue&type=template&id=40e0f34e&"
import script from "./TkRightArrowButton.vue?vue&type=script&lang=js&"
export * from "./TkRightArrowButton.vue?vue&type=script&lang=js&"
import style0 from "./TkRightArrowButton.vue?vue&type=style&index=0&id=40e0f34e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports